import CustomFieldProto from '../../proto/custom-field-proto'
import ListComponent from './components/color-list'
import ViewComponent from './components/color-view'
import EditComponent from './components/edit'
import FormComponent from "./components/form"
import FormNewComponent from './components/color-form-new'
import normalizeNumber from "../../import/normalize/normalize-number"
import FieldColorViewInImport from "../../import/view-in-preview/color-view-in-import"
import renderColorGroupTListHeader1 from "./components/color-group-t-list-header-1";
import renderColorGroupTListHeader2 from "./components/color-group-t-list-header-2";

export default class ColorCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField)
    }

    getCsvValue(item) {
        const { customFieldsData } = item;
        return !_.isNil(customFieldsData[this.customField.id]) ? customFieldsData[this.customField.id] : ''
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.customFieldsData[this.customField.id]],
            directions: [sort]
        }
    }

    listItemGroupFunction() {
        return i=>i.item.customFieldsData[this.customField.id] ? i.item.customFieldsData[this.customField.id] : null
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id)
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id)
    }

    get TListGroupHeader1Component() {
        return renderColorGroupTListHeader1.bind(null, this.customField.id);
    }

    get TListGroupHeader2Component() {
        return renderColorGroupTListHeader2.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id)
    }

    get FormAddComponent() {
        return FormComponent
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id)
    }

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeNumber(value)
    }

    getComponentViewInImport() {
        return FieldColorViewInImport
    }
}